import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { ISchedule, IScheduleDetails } from './schedule.interface';

export namespace ScheduleAction {
  const actionCreator = actionCreatorFactory('Schedule');

  export const load = actionCreator.async<{ scheduleId: ISchedule['scheduleId'] }, IScheduleDetails, IApiErrorParams>('LOAD');
  export const loadList = actionCreator.async<{}, ISchedule[], IApiErrorParams>('LOAD_LIST');

  export const create = actionCreator.async<ISchedule, { scheduleId: ISchedule['scheduleId'] }, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ISchedule, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ scheduleId: ISchedule['scheduleId'] }, void, IApiErrorParams>('REMOVE');
  export const exportFile = actionCreator.async<{}, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
